import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/subscribebanner.jpeg";
import { Link, useNavigate } from "react-router-dom";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import Swal from "sweetalert2";

function Pricing() {
  const [stateObj, setStateObj] = useState({ individual: 3, company: 3 });
  const navigate = useNavigate();
  const individualPricing = [{ amount: 1500, type: "1 Month", days: 30, contacts: 10, mode: "Mly", tag: "Explore opportunities", btn: "Join 1-Month Plan" },
  { amount: 4000, type: "3 Months", days: 90, contacts: 32, mode: "Qly", tag: "Manage short projects", btn: "Join 3-Month Plan" },
  { amount: 7000, type: "6 Months", days: 180, contacts: 70, mode: "Hly", tag: "Build a steady pipeline", btn: "Join 6-Month Plan" },
  { amount: 12000, type: "1 Year", days: 365, contacts: 160, mode: "Yly", tag: "Expand reach and networ", btn: "START YOUR CAREER" }
  ];
  const companyPricing = [{ amount: 2500, type: "1 Month", days: 30, contacts: 10, mode: "Mly", tag: "Short-term access", btn: "Join 1-Month Plan" },
  { amount: 7000, type: "3 Months", days: 90, contacts: 35, mode: "Qly", tag: "Consistent outreach", btn: "Join 3-Month Plan" },
  { amount: 12000, type: "6 Months", days: 180, contacts: 80, mode: "Hly", tag: "Suitable for ongoing needs", btn: "Join 6-Month Plan" },
  { amount: 20000, type: "1 Year", days: 365, contacts: 200, mode: "Yly", tag: "Maximum access and flexibility", btn: "SUBSCRIBE ANNUALLY" }
  ];

  useEffect(() => {
    if (localStorage.getItem("token")) GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("accounts.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };

  const BuyContract = async (_selected, _package) => {
    if (stateObj.activestatus === "Active") {
      return errorToast("Subscribed Already");
    }
    if (!localStorage.getItem("token")) {
      return navigate("/login");
    }
    if (_selected === 1 && stateObj.usertypecategory === "Company") {
      return errorToast(
        "You are registered as a company. Please subscribe to business plan."
      );
    } else if (_selected === 2 && stateObj.usertypecategory === "Individual") {
      return errorToast(
        "You are registered as a individual. Please subscribe to pro plan."
      );
    }

    let res = await ApiRequest(
      "createorder.asp",
      "POST",
      JSON.stringify({ package: _package.amount, mode: _package.mode }),
      {
        Authorization: localStorage.getItem("token"),
      }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    const options = {
      key: "rzp_live_nHQeth5N1SyPIF", // Replace with your Razorpay key
      amount: res.amount,
      currency: res.currency,
      name: "HappieDealz",
      description: stateObj.usertypecategory === "Company" ? "Business Plan Purchase" : "Pro Plan Purchase",
      order_id: res.id,
      handler: async function (response) {
        let verifyres = await ApiRequest("verify_payment.asp", "POST", JSON.stringify({
          order_id: response.razorpay_order_id,
          payment_id: response.razorpay_payment_id,
          signature: response.razorpay_signature,
        }), { Authorization: localStorage.getItem("token") });
        if (verifyres.status === "error") {
          errorToast(verifyres.message);
          if (verifyres.message === "Token Expired") {
            localStorage.clear();
            return navigate("/login");
          }
          return;
        }
        Swal.fire({ title: "Success", icon: 'success', text: verifyres.message });
      },
      prefill: {
        name: stateObj.fullname,
        email: "info@happiedealz.com",
        contact: "9884809607",
      },
      theme: {
        color: "#672769",
      },
      modal: {
        ondismiss: async function () {
          let response = await ApiRequest("verify_payment.asp", "POST", JSON.stringify({
            razorpay_order_id: res.id,
            razorpay_payment_id: "",
            razorpay_signature: "",
          }), { Authorization: localStorage.getItem("token") });
          Swal.fire({ title: "Error", icon: 'error', text: "Payment failed or declined by user." });
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Simple Subscription. Global Marketing Access.</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Subscription Plan
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb bg-white">
        <div class="container">
          <div class="section-title center-block text-center">
            <p>A transparent, subscription-based platform connecting businesses
              and freelance marketers worldwide. Clear pricing. Direct connections.
              No hidden platform charges. Whether you are a Business Person or a
              Marketer, you can create your profile either as a company or as an
              Individual based on your need.</p>
          </div>
        </div>
        <div class="container mt-5">
          <div class="section-title center-block text-center">
            <h2>Subscription Packages – To create a company profile</h2>
          </div>
          <div class="container">
            <div class="row">
              {
                companyPricing.map((item) => {
                  return <div class="col-md-12 col-lg-3 col-xl-3 col-sm-12 mt-2">
                    <div className="card" style={{ borderRadius: 20 }}>
                      <div
                        class="pricingTable card-body"
                        style={{ borderRadius: 20 }}
                      >
                        <div
                          class="price-value mb-5 text-start text-black ms-5"
                          style={{ fontSize: 30 }}
                        >
                          <span className="month text-black">
                            {item.type}
                          </span>
                          ₹{item.amount}
                        </div>


                        <ul class="pricing-content text-start mx-3">
                          <li>
                            <i className="me-2 fa fa-users removeMargin"></i>
                            {item.contacts} contact credits
                          </li>
                          <li>
                            <i className="me-2 fa fa-calendar removeMargin"></i>
                            use credit within {item.days} days.
                          </li>
                        </ul>
                        <p className="text-start mt-2 mx-2" >{item.tag}</p>
                        <button
                          class="btn btn-primary mt-2 py-2 ps-5" style={{ borderRadius: 25 }}
                          onClick={() => BuyContract(2, item)}
                        >
                          {item.btn} <span className="ms-2 bg-white px-2 py-1" style={{ borderRadius: 25 }}><i className="fa fa-arrow-right text-primary" /></span>
                        </button>
                      </div>
                    </div>
                  </div>
                })
              }
            </div>
          </div>
        </div>

        <hr />
        <div class="container mt-5">
          <div class="section-title center-block text-center">
            <h2>Subscription Packages - For Individual Growth</h2>
          </div>
          <div class="container">
            <div class="row">
              {
                individualPricing.map((item) => {
                  return <div class="col-md-12 col-lg-3 col-xl-3 col-sm-12 mt-2">
                    <div className="card" style={{ borderRadius: 20 }}>
                      <div
                        class="pricingTable card-body"
                        style={{ borderRadius: 20 }}
                      >
                        <div
                          class="price-value  text-start mb-5 text-black ms-5"
                          style={{ fontSize: 30 }}
                        >
                          <span className="month text-black">{item.type}</span>
                          ₹{item.amount}
                        </div>


                        <ul class="pricing-content text-start mx-3">
                          <li>
                            <i className="me-2 fa fa-users removeMargin"></i>
                            {item.contacts} contact credits
                          </li>
                          <li>
                            <i className="me-2 fa fa-calendar removeMargin"></i>
                            use credit within {item.days} days.
                          </li>
                        </ul>
                        <p className="text-start mt-2 mx-2" >{item.tag}</p>
                        <button
                          class="btn btn-primary mt-2 py-2 ps-5" style={{ borderRadius: 25 }}
                          onClick={() => BuyContract(1, item)}
                        >
                          {item.btn} <span className="ms-2 bg-white px-2 py-1" style={{ borderRadius: 25 }}><i className="fa fa-arrow-right text-primary" /></span>
                        </button>
                      </div>
                    </div>
                  </div>
                })
              }
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Pricing;
